import React from 'react';
import { GridCol } from '@naf/grid';
import { Text, TextVariant } from '@naf/text';
import { NavCard } from '@components/simba-cards';
import { CenterProductArticleType } from '@appTypes/centerProductArticleType';
import { NavCardLink } from '@components/styled-link/StyledLink';
import { nafCenterBasePath } from '../../../../../routers/NafCenterRouter';
import * as S from './ProductCard.styles';

export const ProductCard = ({
  otherProducts,
}: {
  otherProducts: CenterProductArticleType['relatedProductArticles'];
}) => (
  <S.OtherTests>
    <GridCol s="12" m="12" l="12" xl="12">
      <Text variant={TextVariant.Header2}>Andre tjenester</Text>
    </GridCol>
    {otherProducts?.map((product) => (
      <S.ShortCutCol s="12" m="6" l="4" xl="4" key={product.title}>
        <NavCardLink
          to={(product.link && product.link.data && `/${nafCenterBasePath}/${product.link.data.slug}`) || ''}
        >
          <NavCard title={product.title} description={product.ingress} isInternalLink height="100%" />
        </NavCardLink>
      </S.ShortCutCol>
    ))}
  </S.OtherTests>
);
